import '../Footer/style.css'

export default function Footer(){
return(
    <footer >
        <strong> © 2025 OdontoCare</strong>  Todos os direitos reservados
      </footer>
)
}